import { dataCaretRight } from 'dls-icons-data'
import { createIcon } from '../common'

const IconCaretRight = /*#__PURE__*/createIcon(dataCaretRight)
export default IconCaretRight
